import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/Login';
import Callback from '@/components/Callback';
import Chat from '@/components/chat/index';
import DashboardSummary from '@/components/Dashboard';

import { requireAuth } from '../utils/auth';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Login',
    component: Login
  }, {
    path: '/callback',
    name: 'Callback',
    component: Callback
  }, {
    path: '/summary',
    beforeEnter: requireAuth,
    component: DashboardSummary,
    children: [{
      path: ':accountid',
      name: 'Chat',
      component: Chat
    }]
  }]
});



// WEBPACK FOOTER //
// ./src/router/index.js